import request, { type CustomizeConfigType } from '@/utils/request';
import { stringifySearchParams } from '@/utils/url';
import axios from 'axios';
import { mockApiAsyncRequest } from '@/utils/mock'; // 导入mock函数（与 tom-ui 一致）

const ajaxCache = {};

function apiFactory(serviceName: string, methods: string[]) {
  type ServiceType = {
    [key: string]: (data?: any, config?: CustomizeConfigType) => Promise<any> & { abort: Function };
  };
  const serviceObject: ServiceType = methods.reduce((service, method) => {
    service[method] = (data: any, config?: CustomizeConfigType) => {
      const customizeConfig: CustomizeConfigType = Object.assign({
        throwError: true,
      }, config ?? {});
      const api = data?.api;
      let action = `/${serviceName}/${method}`;
      if (['/App/ajaxProcess'].includes(action)
        && !data?.jsondata
        && data?.form
      ) {
        try {
          const jsonFormData = JSON.stringify(data.form);
          if (jsonFormData != '{}') {
            data.form = jsonFormData;
            data.jsondata = true;
          }
        } catch { }
      }
      if (api) {
        action += '?api=' + encodeURIComponent(api);
      }
      // 如果启用mock，直接返回mock数据（与 tom-ui 逻辑一致）
      if (process.env.NODE_ENV == 'development') {
        try {
          const formData = data?.jsondata ? JSON.parse(data?.form) : data?.form;
          return mockApiAsyncRequest(data?.api, formData || {});
        } catch { }
      }
      let requestParams = {
        method: 'post',
        url: action,
        responseType: 'json',
        data: data instanceof FormData
          ? data
          : stringifySearchParams(data),
        __customizeConfig: customizeConfig,
      } as any;

      if (customizeConfig.getAbort) {
        const source = axios.CancelToken.source();
        requestParams.cancelToken = source.token;
        customizeConfig.getAbort(source.cancel);
      }

      // 缓存支持
      if (config?.cache) {
        const catheKey = [
          config.cache == 'route'
            ? window.location.href
            : null,
          serviceName, method, JSON.stringify(data)
        ].filter(Boolean).join('_');
        const cache = ajaxCache[catheKey];
        if (cache) {
          return cache;
        } else {
          return ajaxCache[catheKey] = request(requestParams)
            .catch(() => delete ajaxCache[catheKey]);
        }
      }
      return request(requestParams);
    };
    return service;
  }, {});
  return serviceObject;
}

export default apiFactory;
